<template>
  <ProviderTableSelection @select="handleSelect" />
</template>

<script>
import ProviderTableSelection from '@/components/ProviderTableSelection.vue';

export default {
  name: 'CostPricesInstructions',
  components: {
    ProviderTableSelection
  },

  methods: {
    handleSelect(provider) {
      this.$router.push({
        name: 'cost-prices-instructions-detail',
        params: { providerId: provider.id }
      });
    }
  }
};
</script>
